import { PureComponent } from "react";

import { DiscussionLink } from "commonComponents/entity/discussion/DiscussionLink/DiscussionLink";
import { type IDiscussionLinkResponse } from "commonComponents/utilities/Discussions/DiscussionLinkCompact";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

class DiscussionLargeCell extends PureComponent<IGridCellRenderProps<IDiscussionLinkResponse>> {
    render() {
        const { cellValue } = this.props;
        return cellValue ? (
            <DiscussionLink
                id={cellValue.id}
                entityType={cellValue.entityType}
                builderId={cellValue.builderId}
                jobId={cellValue.jobId}
                commentCount={cellValue.commentCount}
                unreadCommentCount={cellValue.unreadCommentCount}
                buttonSize="small"
            />
        ) : null;
    }
}

export const columnDiscussionLarge: IClientGridColumn<IDiscussionLinkResponse> = {
    columnType: GridColumnType.discussionLarge,
    Cell: DiscussionLargeCell,
};
